import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const columns = [
    {
      title: 'Product',
      links: [
        { label: 'Capabilities', href: '#capabilities' },
        { label: 'Process', href: '#process' },
        { label: 'Results', href: '#case-studies' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About', href: '#about' },
        { label: 'Contact', href: '#contact' },
        { label: 'Careers', href: 'mailto:hello@datryx.co?subject=Careers', external: true },
      ],
    },
  ];

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string): void => {
    if (href.startsWith('#')) {
      e.preventDefault();
      document.getElementById(href.substring(1))?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <a href="#home" className="logo" onClick={(e) => handleLinkClick(e, '#home')}>
              <span className="logo-mark" aria-hidden="true">
                <span className="logo-dot" />
                <span className="logo-dot" />
                <span className="logo-dot" />
                <span className="logo-dot" />
              </span>
              <span className="logo-word">Datryx</span>
            </a>
            <p>
              The agentic operations layer. We deploy autonomous AI and automation
              pipelines that run the work your team shouldn&rsquo;t have to.
            </p>
            <div className="footer-socials">
              <a
                href="https://linkedin.com/company/datryx"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="social-icon"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="mailto:hello@datryx.co"
                aria-label="Email"
                className="social-icon"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div className="footer-columns">
            {columns.map((col) => (
              <div key={col.title} className="footer-column">
                <h4>{col.title}</h4>
                {col.links.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    onClick={(e) => !link.external && handleLinkClick(e, link.href)}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            ))}

            <div className="footer-column">
              <h4>Contact</h4>
              <a href="mailto:hello@datryx.co">hello@datryx.co</a>
              <span>+44 7466 152039</span>
              <span>London, United Kingdom</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Datryx. All rights reserved.</p>
          <p className="footer-bottom-sub">Agents running quietly somewhere, right now.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
